import BtnOptions from './BtnOptions';
import SelectPlants from '../../../../components/form/Selects/SelectPlants';

const Report10Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <SelectPlants
            type="userPlants"
            format="m"
            value={values.customPlants}
            onHandleChange={(opt) => {
              handleOnSetFieldValue('customPlants', opt);
            }}
            isMulti
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={
                  !values.customPlants || values.customPlants.length === 0
                }
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report10Options;
